module.exports = __webpack_public_path__ + "202669:9205d1a92be8207f1496/img/big_image@1x.11ddb5c.jpg";